import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../styles/SidebarNav.scss";

const SidebarMenu = ({
    isSchoolTemplate,
    navCollapsed,
    selectedLink,
    setLabelObj,
    setNavCollapsed,
    setSelectedLink
}) => {
    const navigate = useNavigate();
    const handleOnClick = (linkName) => {
        const array = linkName.split("/").map((str) => {
            return { label: str, path: `/${str}` };
        });
        setSelectedLink(linkName);
        if (linkName !== "HOME") {
            setLabelObj(array);
        }
        if (linkName === "HOME") {
            setLabelObj([{ label: "Home", path: "/home" }]);
        }
        navigate(`/${linkName.split(" ")[0].toLowerCase()}`);
    };

    const collapsedTemplateRowClass = (() => {
        if (selectedLink === "HOME/TEMPLATE") return "selected-row";
        if (selectedLink.includes("HOME/TEMPLATE/DEFINE")) return "child-selected";
        return "not-selected-row";
    })();

    return (
        <>
            {!navCollapsed && (
                <div className="expanded-nav-container">
                    <button
                        type="button"
                        className="expanded-nav-arrow-row nav-toggle-button"
                        onClick={() => setNavCollapsed(true)}
                    >
                        <i className={`bi bi-arrow-bar-left white arrow-icon`}></i>
                    </button>
                    <button
                        type="button"
                        className={`expanded-nav-row nav-row-button ${selectedLink === "HOME" ? "selected-row" : "not-selected-row"}`}
                        onClick={() => handleOnClick("HOME")}
                    >
                        <i className={`bi bi-house-fill ${selectedLink === "HOME" ? "dk-blue" : "white"}`}></i>
                        <span className={`expanded-nav-link ${selectedLink === "HOME" ? "dk-blue" : "white"}`}>
                            Home
                        </span>
                    </button>
                    <button
                        type="button"
                        className={`expanded-nav-row nav-row-button ${selectedLink === "HOME/OVERVIEW" ? "selected-row" : "not-selected-row"}`}
                        onClick={() => handleOnClick("HOME/OVERVIEW")}
                    >
                        <i
                            className={`bi bi-card-checklist ${selectedLink === "HOME/OVERVIEW" ? "dk-blue" : "white"}`}
                        ></i>
                        <span className={`expanded-nav-link ${selectedLink === "HOME/OVERVIEW" ? "dk-blue" : "white"}`}>
                            Report Card Overview
                        </span>
                    </button>
                    <button
                        type="button"
                        className={`expanded-nav-row nav-row-button ${selectedLink === "HOME/TEMPLATE" ? "selected-row" : "not-selected-row"}`}
                        onClick={() => handleOnClick("HOME/TEMPLATE")}
                    >
                        <i
                            className={`bi bi-card-checklist ${selectedLink === "HOME/TEMPLATE" ? "dk-blue" : "white"}`}
                        ></i>
                        <span className={`expanded-nav-link ${selectedLink === "HOME/TEMPLATE" ? "dk-blue" : "white"}`}>
                            School Template
                        </span>
                    </button>
                    {selectedLink.includes("TEMPLATE") && isSchoolTemplate && (
                        <button
                            type="button"
                            className={`expanded-nav-sub-row nav-row-button ${selectedLink.includes("HOME/TEMPLATE/DEFINE") ? "selected-row" : "not-selected-row"}`}
                            onClick={() => handleOnClick("HOME/TEMPLATE/DEFINE REPORTING PERIODS")}
                        >
                            <div
                                className={`expanded-nav-link ${selectedLink.includes("HOME/TEMPLATE/DEFINE") ? "dk-blue" : "white"}`}
                            >
                                Define Reporting Periods
                            </div>
                        </button>
                    )}
                    <button
                        type="button"
                        className={`expanded-nav-row nav-row-button ${selectedLink === "HOME/SLES" ? "selected-row" : "not-selected-row"}`}
                        onClick={() => handleOnClick("HOME/SLES")}
                    >
                        <i className={`bi bi-bookmark-star ${selectedLink === "HOME/SLES" ? "dk-blue" : "white"}`}></i>
                        <span className={`expanded-nav-link ${selectedLink === "HOME/SLES" ? "dk-blue" : "white"}`}>
                            SLEs
                        </span>
                    </button>

                    <button
                        type="button"
                        className={`expanded-nav-row nav-row-button ${selectedLink === "HOME/STUDENT-SEARCH" ? "selected-row" : "not-selected-row"}`}
                        onClick={() => handleOnClick("HOME/STUDENT-SEARCH")}
                    >
                        <i
                            className={`bi bi-search ${selectedLink === "HOME/STUDENT-SEARCH" ? "dk-blue" : "white"}`}
                        ></i>
                        <span
                            className={`expanded-nav-link ${selectedLink === "HOME/STUDENT-SEARCH" ? "dk-blue" : "white"}`}
                        >
                            Student Search
                        </span>
                    </button>
                </div>
            )}
            {navCollapsed && (
                <div className="collapsed-nav-container">
                    <button
                        type="button"
                        className="collapsed-nav-row nav-toggle-button"
                        onClick={() => setNavCollapsed(false)}
                    >
                        <i className={`bi bi-arrow-bar-right white arrow-icon`}></i>
                    </button>
                    <button
                        type="button"
                        className={`collapsed-nav-row ${selectedLink === "HOME" ? "selected-row" : "not-selected-row"}`}
                        onClick={() => handleOnClick("HOME")}
                    >
                        <i className={`bi bi-house-fill ${selectedLink === "HOME" ? "dk-blue" : "white"}`}></i>
                    </button>
                    <button
                        type="button"
                        className={`collapsed-nav-row ${selectedLink === "HOME/OVERVIEW" ? "selected-row" : "not-selected-row"}`}
                        onClick={() => handleOnClick("HOME/OVERVIEW")}
                    >
                        <i
                            className={`bi bi-card-checklist ${selectedLink === "HOME/OVERVIEW" ? "dk-blue" : "white"}`}
                        ></i>
                    </button>
                    <button
                        type="button"
                        className={`collapsed-nav-row ${collapsedTemplateRowClass}`}
                        onClick={() => handleOnClick("HOME/TEMPLATE")}
                    >
                        <i
                            className={`bi bi-card-checklist ${selectedLink === "HOME/TEMPLATE" ? "dk-blue" : "white"}`}
                        ></i>
                    </button>
                    <button
                        type="button"
                        className={`collapsed-nav-row ${selectedLink === "HOME/SLES" ? "selected-row" : "not-selected-row"}`}
                        onClick={() => handleOnClick("HOME/SLES")}
                    >
                        <i className={`bi bi-bookmark-star ${selectedLink === "HOME/SLES" ? "dk-blue" : "white"}`}></i>
                    </button>
                    <button
                        type="button"
                        className={`collapsed-nav-row ${selectedLink === "HOME/STUDENT-SEARCH" ? "selected-row" : "not-selected-row"}`}
                        onClick={() => handleOnClick("HOME/STUDENT-SEARCH")}
                    >
                        <i className={`bi bi-search ${selectedLink === "HOME/STUDENT-SEARCH" ? "dk-blue" : "white"}`} />
                    </button>
                </div>
            )}
        </>
    );
};

SidebarMenu.propTypes = {
    isSchoolTemplate: PropTypes.bool,
    navCollapsed: PropTypes.bool,
    selectedLink: PropTypes.string,
    setLabelObj: PropTypes.func,
    setNavCollapsed: PropTypes.func,
    setSelectedLink: PropTypes.func
};

export default SidebarMenu;
